const placeTypeList = [
    { value: 1, label: '场馆' },
    { value: 2, label: '酒店' },
    { value: 3, label: '参访点' },
]

export function getPlaceConfig(type) {
    const item = placeTypeList.find(p => p.value == type);
    const typeName = item.label;
    return {
        name: typeName,
        url: '/admin/venue-hotel-visit', // rest接口表名
        query: `&sort=sort&filter[type]=${type}`, // rest接口query参数
        // 列表渲染列
        columns: ctx => {
            // eslint-disable-next-line no-unused-vars
            const h = ctx.$createElement
            return [
                {title: '序号', dataIndex: 'sort'},
                {title: `${typeName}名称`, dataIndex: 'name'},
                {title: '地址', dataIndex: 'address'},
            ]
        },
        // 列表查询表单
        queryForm: [
            {
                key: 'name',
                label: '',
                component: 'a-input',
                props: {
                    placeholder: `请输入${typeName}名称搜索`,
                },
            },
        ],
        // 新增/编辑查询表单
        items: [
            {
                key: 'name',
                label: `${typeName}名称`,
                component: 'a-input',
                props: {
                    placeholder: `请输入${typeName}名称`,
                },
                rules: [{ required: true, message: `请输入${typeName}名称`, trigger: 'blur' }]
            },
            {
                key: 'location',
                label: '选择位置',
                component: 'coordinate-picker',
                listeners: {
                    change(val) {
                        if(val) {
                            this.$set(this.form, 'address', val.address);
                            this.$set(this.form, 'coordinate', val.latLng);
                        }
                    }
                }
            },
            {
                key: 'address',
                label: '地址',
                component: 'a-input',
                props: {
                    placeholder: `请输入${typeName}地址`,
                },
                rules: [{ required: true, message: `请输入${typeName}地址`, trigger: 'blur' }]
            },
            {
                key: 'coordinate',
                label: '经纬度',
                component: 'a-input',
                props: {
                    placeholder: `请输入${typeName}经纬度，例：30.245772,120.210042`,
                },
                rules: [{ required: true, message: `请输入${typeName}经纬度`, trigger: 'blur' }]
            },
            {
                key: 'info',
                label: `${typeName}介绍`,
                component: 'a-textarea',
                props: {
                    placeholder: '请输入',
                    autoSize: { minRows: 4, maxRows: 8 }
                },
                style: {
                    width: '100%'
                },
                rules: [{ required: true, message: `请输入${typeName}介绍`, trigger: 'blur' }]
            },
            {
                key: 'img',
                label: `${typeName}图片`,
                component: 'form-upload',
                props: {
                    limit: 9,
                    size: 10 * 1024,
                    tip: "最多上传9张，图片大小不超过10M"
                },
                rules: [{ required: true, message: '请上传图片', trigger: 'change' }]
            },
            {
                key: 'sort',
                label: '序号',
                component: 'a-input-number',
                props: {
                    placeholder: '数字越小，排位越前',
                },
                style: {
                    width: '100%'
                },
                rules: [{ required: true, message: '请输入序号', trigger: 'blur' }]
            },
        ],
        // 详情接口expand字段
        expand: '',
        init: {}, // 新增实体初始化字段
        // 详情渲染字段
        renderItems: (ctx) => {
            // eslint-disable-next-line no-unused-vars
            const h = ctx.$createElement;
            const res = [
                {
                    label: `${typeName}名称`,
                    key: 'name',
                },
                {
                    label: '地址',
                    key: 'address',
                },
                {
                    label: '坐标',
                    key: 'coordinate',
                },
                {
                    label: `${typeName}介绍`,
                    key: 'info',
                    textarea: true
                },
                {
                    label: `${typeName}图片`,
                    key: 'img',
                    img: true
                },
                {
                    label: '序号',
                    key: 'sort',
                },
            ];
            return res;
        },

        beforeUpdate: function (form) {
            return new Promise(resolve => {
                if(!form.id) {
                    form.type = type;
                }
                resolve(form);
            })
        },
    }
}
